import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {Controller} from "react-hook-form";
import {TextField} from "@mui/material";
import dayjs from "dayjs";
import Calendar from '@mui/icons-material/Event';
import React, { useCallback, useMemo } from 'react';

export interface BfADatePickerProps {
    name: string;
    label: string;
    control: any;
    defaultValue?: any;

}

function BfADatePicker({
                            name,
                            label,
                            control,
                            defaultValue,
                        }: BfADatePickerProps) {
    const textFieldSlot = useCallback((props: any, fieldState: any) => (
        <TextField
            key={`text-${name}`}
            fullWidth
            sx={{ width: '100%' }}
            {...props}
            error={Boolean(fieldState.error)}
            helperText={fieldState?.error?.message}
        />
    ), [name]);

    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue ?? null}
            render={({ field: { onChange, value, ref, name }, fieldState }) => (
                <LocalizationProvider adapterLocale={'de'} dateAdapter={AdapterDayjs}>
                    <DatePicker
                        key={name}
                        sx={{marginTop: '15px'}}
                        onChange={onChange}
                        value={value ? dayjs(value) : null}
                        label={label}
                        ref={ref}
                        slots={{
                            textField: (props: any) => textFieldSlot(props, fieldState)
                        }}
                    />
                </LocalizationProvider>
            )}
        />
    );
}

export default BfADatePicker;